import { Amplify } from 'aws-amplify'

export function configureAmplify(liveMode: boolean): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId:liveMode  === true ? "eu-central-1_BrSBFTYHr" :'eu-central-1_BcUIDe4mc',
        userPoolClientId:liveMode  === true ? '2h9jkcs2p4l752jvljf7c3opu' : '68r95momuqu4fcaa18n39ukfai',
        loginWith: {
          phone: true,
        },
        signUpVerificationMethod: 'code',
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
  })
}